
export const phoneValidator = {
 pattern: new RegExp(/^(?:\+1|1)?[\s-]?(\(\d{3}\)|\d{3})[\s-]?\d{3}[\s-]?\d{4}$/),
 invalid: "Please enter a valid phone number!"
}

export const emailValidator = {
 pattern: new RegExp( /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
 invalid: "Please enter a valid email!"
}


export const fullNameValidator = {
 pattern: new RegExp(/^([A-Za-zÀ-ÖØ-öø-ÿ\-']+\s+)+([A-Za-zÀ-ÖØ-öø-ÿ\-']+)+$/),
 invalid: "Please enter a valid Name!"
}

export const zipcodeValidator = {
 pattern: new RegExp(/^\d{5}$/), // for 9 digits with hyphen: ^\d{5}(-\d{4})?$
 invalid: "Please enter a valid Zip Code!"
}

export const nomailValidator = {
 pattern: new RegExp(/nomail\.nomail/),
 invalid: "Email is not a nomail!"
}

export const dobValidator = {
 pattern: new RegExp(/^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/
 ),
 invalid: "Date of birth should be in MM/DD/YYYY format!"
}